import type {
  RiderPayrollPaymentMethod,
  RiderPayrollStatus,
} from "@artisancode/api-types";

export const RIDER_PAYROLL_STATUS_LABELS: Record<RiderPayrollStatus, string> = {
  draft: "Draft",
  paid: "Dibayar",
  cancelled: "Dibatalkan",
};

export const RIDER_PAYROLL_PAYMENT_METHOD_LABELS: Record<
  RiderPayrollPaymentMethod,
  string
> = {
  cash: "Tunai",
  edc: "EDC",
  qris: "QRIS",
  app_qris: "App QRIS",
  bank_transfer: "Transfer",
};
